import {
  FormHeader,
  FormSection,
  Dropdown,
  DropdownButtonBlue,
  ArrowDown,
  CandidatesDropdownMenu,
  DropdownItem,
  Note,
} from './styles';
import { Checkbox } from 'components/Checkbox/Checkbox';

const ColleaguesListing = ({ colleaguesList, setColleaguesList }) => {
  const selectedColleagueCount = colleaguesList?.filter((colleague) => colleague.selected).length;

  const setColleagueChecked = (colleagueIndex, checked) => {
    let updatedList = colleaguesList.map((colleague, index) => {
      if (colleagueIndex === index) return { ...colleague, selected: checked };
      return colleague;
    });
    setColleaguesList(updatedList);
  };

  const renderColleaguesDropdownMenu = () => {
    return colleaguesList?.map((colleague, index) => {
      return (
        <DropdownItem key={index} onClick={(e) => e.stopPropagation()}>
          <Checkbox
            checked={colleague.selected ?? false}
            label={colleague.name}
            onChange={() => {
              setColleagueChecked(index, !colleaguesList[index]?.selected);
            }}
          />
        </DropdownItem>
      );
    });
  };

  return (
    <FormSection>
      <FormHeader>Share test report with:</FormHeader>
      <Dropdown>
        <DropdownButtonBlue id="selectColleaguesDropdownlist" data-toggle="dropdown">
          Select Colleagues {selectedColleagueCount > 0 && `(${selectedColleagueCount} selected) `}
          <ArrowDown />
        </DropdownButtonBlue>
        <CandidatesDropdownMenu>{renderColleaguesDropdownMenu()}</CandidatesDropdownMenu>
      </Dropdown>
      {selectedColleagueCount > 0 && (
        <Note>
          Sharing test reports with{' '}
          {colleaguesList
            ?.filter((colleague) => colleague.selected)
            .map((colleague) => colleague.name)
            .join(', ')}
          .
        </Note>
      )}
    </FormSection>
  );
};

export default ColleaguesListing;
